import i18nFactory from '@yandex-int/i18n';
import { PopupDirection } from 'lego-on-react';
import * as React from 'react';

import { FeedFilterPriorityFormContainer } from '../../containers/FeedFilterPriorityFormContainer/FeedFilterPriorityFormContainer';
import { makeGridPopupContainer } from '../../containers/GridPopup/GridPopup';
import { mapAutobudgetPriorityToString } from '../../service/PhrasesHelpers/PhrasesHelpers';
import { BasePopupProps } from '../../typings/common';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';
import { EditableCell } from '../EditableCell/EditableCell';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';

import * as keyset from './FeedFilterPriorityCellEditor.i18n';

export interface FeedFilterPriorityCellEditorProps {
    isSaving: boolean;
    error?: string;
    autobudgetPriority?: GdShowConditionAutobudgetPriority;
    onCancel: () => void;
    onSave: () => void;
    onInitialValuesSet: (autobudgetPriority: GdShowConditionAutobudgetPriority) => void;
}

type FeedFilterPriorityCellEditorBaseProps = FeedFilterPriorityCellEditorProps & BasePopupProps;

const i18n = i18nFactory(keyset);

const POPUP_DIRECTIONS: Array<PopupDirection> = ['bottom-center', 'top-center', 'left-center', 'right-center'];

class FeedFilterPriorityCellEditorBase extends React.Component<FeedFilterPriorityCellEditorBaseProps> {
    componentDidUpdate(prevProps: FeedFilterPriorityCellEditorBaseProps) {
        if (
            (prevProps.isSaving !== this.props.isSaving || prevProps.error !== this.props.error) &&
            !this.props.isSaving &&
            !this.props.error
        ) {
            this.props.closePopup();
        }
    }

    render() {
        const { autobudgetPriority, isPopupVisible } = this.props;

        return (
            <>
                <EditableCell onClick={this.onTogglePopup} isActive={isPopupVisible}>
                    {autobudgetPriority ? mapAutobudgetPriorityToString(autobudgetPriority) : i18n('empty-priority')}
                </EditableCell>
                {this.getPopup()}
            </>
        );
    }

    private onTogglePopup = () => {
        const { isPopupVisible, autobudgetPriority, switchPopupState, onInitialValuesSet } = this.props;

        switchPopupState();

        if (!isPopupVisible) {
            onInitialValuesSet(autobudgetPriority || GdShowConditionAutobudgetPriority.MEDIUM);
        }
    };

    private onPopupClose = () => {
        const { closePopup, onCancel } = this.props;

        closePopup();
        onCancel();
    };

    private getPopup = () => {
        const { isSaving, isPopupVisible, onSave } = this.props;

        return (
            <PopupDecorator
                onOutsideClick={this.onPopupClose}
                anchor={this}
                visible={isPopupVisible}
                target="anchor"
                directions={POPUP_DIRECTIONS}
                header={i18n('title')}
                hasTail={true}
            >
                <FeedFilterPriorityFormContainer isLoading={isSaving} onCancel={this.onPopupClose} onSave={onSave} />
            </PopupDecorator>
        );
    };
}

export const FeedFilterPriorityCellEditor = makeGridPopupContainer<FeedFilterPriorityCellEditorProps>(
    FeedFilterPriorityCellEditorBase
);
